import {ID_TYPES} from "../constant";

export const getIdentityType = (value : keyof typeof ID_TYPES) => {
    return ID_TYPES[value]
}